import useQueryParamsHelper from "./useQueryParamsHelper";
import {SortOrderEnum} from "../commons/enums/sort-order-enum";

const useFilter = () => {
    const {getQueryParams, setQueryParams} = useQueryParamsHelper();
    const statusChange = (status: string = "1") => {
        setQueryParams({status});
    };

    const sortOrderChange = (sortOrder: SortOrderEnum = SortOrderEnum.Descending) => {
        setQueryParams({sortOrder});
    };

    const sortByChange = (sort: string = "createdAt") => {
        setQueryParams({sort});
    };

    const onSearch = (text: string) => {
        setQueryParams({name: text, page: null});
    };

    const sortOrder = (getQueryParams('sortOrder') || SortOrderEnum.Descending) as SortOrderEnum;
    const sortBy = getQueryParams('sort') || "createdAt";
    const searchText = getQueryParams('name') || undefined;
    const status = getQueryParams('status') || '';
    return {
        sortBy,
        sortOrder,
        sortByChange,
        sortOrderChange,
        searchText,
        onSearch,
        status,
        statusChange
    }
}
export default useFilter;